module.exports = __webpack_public_path__ + "img/bgi.843d0bc1.png";